   import { createSlice } from '@reduxjs/toolkit'
   const initialState = {
      principalDetails:null
   }

   export const principalSlice=createSlice({
      name:'principal',
      initialState,
      reducers:{
         setPrincipal:(state, action)=>{
            state.principalDetails=action.payload
         },
         
      }
   })
   export const {setPrincipal}=principalSlice.actions;
   export default principalSlice.reducer